export default __webpack_public_path__ + "src/images/packages/zannier-hotels-sonop/80ab7285d7ac04ba53560c4b19041f5a-4.jpg";